import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { camelCase } from 'lodash';
// eslint-disable-next-line import/no-cycle
import {
  LineItemContainer,
  LineItem,
  LineItemValue,
} from 'components/Comparison/LineItems';
import {
  formatFeatureFactory,
  determineBestFeatureCapabilityFactory,
} from 'components/Comparison/LineItems/helpers';

function determineBestCrashTestRating({ vehicle1, vehicle2 }) {
  if (!vehicle1.safety_rating || !vehicle2.safety_rating) {
    return null;
  }

  if (vehicle1.safety_rating > vehicle2.safety_rating) {
    return vehicle1;
  }
  if (vehicle2.safety_rating > vehicle1.safety_rating) {
    return vehicle2;
  }

  return null;
}

const SAFETY_FEATURES = [
  'autonomous_braking',
  'blind_spot_warning',
  'adaptive_cruise_control',
  'lane_keep_assist',
  'cross_traffic_alert',
];

export default function Safety({ comparison }) {
  const { t } = useTranslation();

  function formatCrashTestRating(vehicle) {
    if (vehicle.safety_rating) {
      return t('comparison.lineItems.safety.stars', {
        count: vehicle.safety_rating,
      });
    }

    return null;
  }

  return (
    <LineItemContainer
      title={t('comparison.lineItems.safety.header')}
      comparison={comparison}
    >
      <LineItem title={t('comparison.lineItems.safety.crashTestResults')}>
        <LineItemValue
          comparison={comparison}
          getValue={formatCrashTestRating}
          getSubText={() => t('comparison.lineItems.safety.overall')}
          determineWinner={determineBestCrashTestRating}
        />
      </LineItem>
      <LineItem title={t('comparison.lineItems.features.safetyFeatures')}>
        {SAFETY_FEATURES.map((safetyFeature) => (
          <LineItemValue
            key={safetyFeature}
            comparison={comparison}
            getValue={formatFeatureFactory(safetyFeature)}
            getSubText={() =>
              t(`comparison.lineItems.features.${camelCase(safetyFeature)}`)
            }
            determineWinner={determineBestFeatureCapabilityFactory(
              safetyFeature
            )}
          />
        ))}
      </LineItem>
    </LineItemContainer>
  );
}
Safety.propTypes = {
  comparison: PropTypes.object,
};
